import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from './../../Redux/Actions/app';
import styled from 'styled-components'
import { Headline3, Overline2, Headline5, Next, Input, Back, ButtonContainer } from './../../Components/Common';
import withRouter from './../../Utilities/withRouter'
import { Industries } from '../../Components/Industries';
import FormApi from '../../Api/base';
import {featureList} from './../Step2/Components/Feature';
import PreviewBox from '../../Components/PreviewBox';
import DevicePreview from '../../Components/PreviewBox/DevicePreview';

const Left = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 0;
    min-width: 845px;
    max-width: 845px;
    flex-grow: 1;
    width: auto;
    height: 785px;
    overflow: hidden;
    box-sizing: border-box;         /* Opera/IE 8+ */
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    @media (min-width: 319px) and (max-width: 767px) {
        height: unset;
        min-width: unset;
        max-width: unset;
        position: unset;
        flex: 1;
        ${Overline2}{
            font-size: 26px;
        }
        ${Headline3} {
            font-size: 35px;
        }
        ${Headline5}{
            font-size: 15px;
        }
    }
    @media (min-width: 768px) and (max-width: 1025px){
        min-width: 404px;
        flex: 1;
        overflow-x: hidden;
        overflow-y: auto;
        ${Overline2}{
            font-size: 26px;
        }
        ${Headline3}{
            font-size: 35px;
        }
        ${Headline5}{
            font-size: 15px;
        }
    }
    @media (min-width: 1025px) and (max-width: 1364px){
        min-width: 404px;
        flex: 1;
        overflow-x: hidden;
        overflow-y: auto;
    }
    
`;
const FormInputContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap 20px;
    margin-top: 20px;
    &>*{
        flex: 1;
        max-width: 60%;
    }
    @media (min-width: 319px) and (max-width: 1360px) {
        flex-wrap: wrap;
        padding-right: 10px;
        &>*{
            max-width: unset;
        }
    }
`;

const Centered = styled.div`
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;
    gap: 10px;
    flex-direction: row;
    padding-left: 60px;
    max-width: 1440px;
    margin: 0px auto auto auto;
    margin-left: auto;
    margin-right: auto;
    overflow-x: hidden;
    overflow-y: auto;

    box-sizing: border-box;         /* Opera/IE 8+ */
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    @media (min-width: 319px) and (max-width: 767px) {
        max-width: 100vw;
        max-height: 100vh;
        overflow-x: hidden;
        overflow-y: auto;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 20px;
        margin: 0px auto auto auto;
        ::-webkit-scrollbar {
            width: 0px;
            background: transparent; /* make scrollbar transparent */
        }
    }
    @media (min-width: 768px) and (max-width: 1025px){
        max-width: 100vw;
        max-height: 100vh;
        overflow-x: hidden;
        overflow-y: auto;
        padding-left: 20px;
        padding-right: 0px;
        padding-top: 0px;
        margin: 0px 0px 0px 0px;
        gap: 0px;
    }
    @media (min-width: 1025px) and (max-width: 1360px){
        max-width: 100vw;
        max-height: 100vh;
        overflow-x: hidden;
        overflow-y: auto;
        padding-left: 20px;
        padding-right: 0px;
        padding-top: 0px;
        margin: 0px 0px 0px 0px;
        gap: 0px;
    }
`;


class Step3 extends Component {
    static propTypes = {
        naviagate: PropTypes.func,
        industry: PropTypes.string,
        features: PropTypes.array
    };
    state = {
        websiteURL: "",
        firstName: "",
        lastName: "",
        phoneNumber: null,
        emailAddress: ""
    }

    componentDidMount(){
        const { navigate, industry } = this.props;
        window.gtag('event', 'screen_view', {
            'app_name': 'App Creator',
            'screen_name': 'Step 3'
        });
        if(!industry){
            setTimeout(()=> navigate('/step-1', {replace:true}));
        }
    }

    simpleValidation = ()=> {
        const { websiteURL, firstName, lastName, emailAddress} = this.state;
        let emailTest = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
        const { industry, features } = this.props;
        return features.length > 0 && industry && websiteURL && firstName && firstName.length > 0 && lastName && lastName.length > 0 && emailAddress && emailAddress.length > 0 && emailTest.test(emailAddress);
    };

    submit = () =>{
        let api = new FormApi();
        const { navigate, industry, features } = this.props;
        const { websiteURL, firstName, lastName,phoneNumber, emailAddress} = this.state;
        let modules = featureList.filter(f => features.indexOf(f.id) > -1).map(f=>f.title);
        const payload = {
            "fields": [
                {
                  "name": "desired_industry",
                  "value": industry
                },
                {
                  "name": "modules",
                  "value": modules.join(', ')
                },
                {
                    "name": "website_url",
                    "value": websiteURL
                  },
                  {
                    "name": "first_name",
                    "value": firstName
                  },
                  {
                    "name": "last_name",
                    "value": lastName
                  },
                  {
                    "name": "email",
                    "value": emailAddress
                  }
            ],
        };
        if(phoneNumber){
            payload.fields.push( {"name": "phone","value": phoneNumber});
        }
        api.post('/3812191/5e925cc9-f4c5-4309-8f31-45de5c36bc1d',null, payload).then(e => navigate('/thank-you')).catch(e => console.log(e));
    }

    render() {
        const { industry, navigate, features } = this.props;
        const { websiteURL, firstName, lastName,phoneNumber, emailAddress} = this.state;
        
       //let industryImage = null;
       let theme = 'light'
       if(industry){
           let index = Industries.findIndex(t => t.id === industry);
           if(index > -1)
               theme = Industries[index].theme;
               //industryImage = Industries[index].preview;
       }
        return (
            <Centered>
            <Left>
                <Headline3 style={{marginTop: "30px"}}><Overline2 style={{fontSize:"30px"}}>Step 3:</Overline2><br/>Content & Contact Info</Headline3>
                <Headline5 style={{marginTop: "36px"}}>Please provide your website URL where we can review and source your content & branding for your app.</Headline5>
                <FormInputContainer><Input placeholder='Website URL' type='url' value={websiteURL} onChange={e => this.setState({websiteURL: e.target.value})} /></FormInputContainer>
                <Headline5 style={{marginTop: "30px"}}>Fill out the contact information and a Sales Director will follow up with you on next steps to getting your app created!</Headline5>
                <FormInputContainer><Input placeholder='First Name' type='text' value={firstName} onChange={e => this.setState({firstName: e.target.value})} /><Input placeholder='Last Name' type='text' value={lastName} onChange={e => this.setState({lastName: e.target.value})}/></FormInputContainer>
                <FormInputContainer><Input placeholder='Email' type='email' value={emailAddress} onChange={e => this.setState({emailAddress: e.target.value})}/> <Input placeholder='Phone Number (Optional)' type='text' value={phoneNumber} onChange={e => this.setState({phoneNumber: e.target.value})}/></FormInputContainer>
                <ButtonContainer>
                    <Back onClick={e => { e.preventDefault(); navigate(`/step-2`);}}>Back</Back>
                    <Next onClick={e => { e.preventDefault(); this.submit()}} disabled={!this.simpleValidation()}>Submit Request</Next>
                </ButtonContainer>
            </Left>
            <PreviewBox title={industry}>
                {/* {industryImage && <img src={industryImage} />} */}
                <DevicePreview industry={industry} features={features} theme={theme} />
            </PreviewBox>
        </Centered>);
    }
}

function stateToProps(state){
    return {...state.app};
};
export default connect(stateToProps,actions)(withRouter(Step3));
